import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { LazyImage } from "react-lazy-images";
// import AvatarLoader from "./AvatarLoader"


export default class DoctorItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      date: null
    };
  }
  render() {
    // if (this.props.params.online_date) {
    //   this.setState({date: this.props.params.online_date})
    //   console.log('filter in doctor item', this.props.params.online_date)
    // }
      
    return (

      <div className="col-6">
        <div className="card card-full-height">
          <div className="card-body">

            <a href={`/doctors/${this.props.doctor.slug}?date=${this.props.params.online_date}&hospital_id=${this.props.params.hospital_id}`} data-remote='true' className="single-doctor-box modal-link" >
              <div className="doctor-image">
                <LazyImage
                  src={this.props.doctor.avatar.thumb.url}
                  alt={this.props.doctor.full_name}
                  actual={({ imageProps }) => <img {...imageProps} />}
                  placeholder={({ ref }) => <div ref={ref} />}
                  loading={() => (
                    <Skeleton circle={true} height={60} width={60} />
                    // <AvatarLoader/>
                  )}
                  error={() => (
                    <Skeleton circle={true} height={60} width={60} />
                  )}
                />
              </div>
              <div className="doctor-content">
                <p className="ellipsis" dangerouslySetInnerHTML={{ __html: this.props.doctor.full_name  }}/>
                <span dangerouslySetInnerHTML={{ __html: this.props.doctor.speciality  }}/>
                <span> <ion-icon name="location"></ion-icon>  {this.props.doctor.practic_location} </span>
              </div>
              
            </a>
          </div>
        </div>
      </div>

    );
  }
}

